import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import ReviewCard from "./ReviewCard";
import { reviews } from "./reviewData";
import styles from "./ReviewSection.module.css";

const ReviewsSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const showNextReview = () => {
    setActiveIndex((prevIndex) =>
      prevIndex === reviews.length - 1 ? 0 : prevIndex + 1,
    );
  };

  const showPreviousReview = () => {
    setActiveIndex((prevIndex) =>
      prevIndex === 0 ? reviews.length - 1 : prevIndex - 1,
    );
  };

  useEffect(() => {
    if (isPaused) return;

    const interval = setInterval(showNextReview, 9000);

    return () => clearInterval(interval);
  }, [isPaused]);

  const activeReview = reviews[activeIndex];

  return (
    <motion.section
      className={styles.reviewsSection}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <p className={styles.eyebrow}>Client Love</p>
      <div className={styles.carouselWrapper}>
        <AnimatePresence mode="wait" initial={false}>
          <motion.div
            key={activeReview.name}
            className={styles.activeReview}
            initial={{
              opacity: 0,
              scale: 0.98,
              filter: "blur(4px)",
            }}
            animate={{
              opacity: 1,
              scale: 1,
              filter: "blur(0px)",
            }}
            exit={{
              opacity: 0,
              scale: 1.02,
              filter: "blur(4px)",
            }}
            transition={{
              duration: 0.8,
              ease: [0.4, 0, 0.2, 1],
            }}
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
            onTouchStart={() => setIsPaused(true)}
            onTouchEnd={() => setIsPaused(false)}
            drag="x"
            dragConstraints={{ left: 0, right: 0 }}
            dragElastic={0.2}
            onDragEnd={(_, info) => {
              const swipeThreshold = 75;

              if (info.offset.x < -swipeThreshold) {
                showNextReview();
              }

              if (info.offset.x > swipeThreshold) {
                showPreviousReview();
              }
            }}
          >
            <ReviewCard name={activeReview.name} review={activeReview.review} />
          </motion.div>
        </AnimatePresence>
        <div className={styles.carouselDots}>
          {reviews.map((review, index) => (
            <button
              key={review.name}
              className={`${styles.dot} ${
                index === activeIndex ? styles.activeDot : ""
              }`}
              onClick={() => setActiveIndex(index)}
              aria-label={`Show review from ${review.name}`}
            />
          ))}
        </div>
      </div>
    </motion.section>
  );
};

export default ReviewsSection;
